export { default } from './view-homepage';
